
export const taskActions = {
    "ADD": "создал задачу",
    "EDIT_ASSIGN": "изменил исполнителей",
    "CLOSE": "закрыл задачу",
    "EDIT": "изменил задачу",
    "EDIT_LABELS": "изменил ярлыки"
}

export const taskActionsIcons = {
    "ADD": "add",
    "EDIT_ASSIGN": "edit",
    "CLOSE": "close",
    "EDIT": "edit",
    "EDIT_LABELS": "edit"
}